export const formFields = (ctx) => {
  return [
    {
      name: '业务类别',
      prop: 'businessCategory',
      type: 'select',
      options: ctx.dictListMap?.businessCategory || [],
      disabled: true,
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'superviseContract',
      extraData: {
        parkCompanyNo: ctx.userInfo.companyCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.query?.contractNo,
      disabled: ctx.status == 'edit',
    },
    {
      name: '客户名称',
      prop: 'customerNo',
      type: 'select',
      options: ctx.customerList,
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '项目编号',
      prop: 'projectInitiationNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
      disabled: true,
    },
  ];
};

export const tableColumnList = (ctx) => {
  return [
    {
      field: 'expenseTypeName',
      title: '费用类型',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
          disabled: true,
        },
      },
      width: 120,
    },
    {
      field: 'accountPeriod',
      title: '应收账期',
      width: 240,
      editRender: {
        name: 'ElDatePicker',
        props: {
          clearable: true,
          valueFormat: 'yyyy-MM',
          format: 'yyyy-MM',
          type: 'month',
        },
      },
    },
    {
      field: 'originalPrice',
      title: '结算单价（含税）',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
      slots: {
        default: ({ row }) => {
          return [<span>{row['originalPrice']}</span>];
        },
        edit: ({ row }) => {
          return [
            <InputNumberAd
              value={row['originalPrice']}
              max={999999999.999999}
              min={0}
              precision={6}
              onInput={(val) => ctx.updateCol(row, val, 'originalPrice')}
            ></InputNumberAd>,
          ];
        },
      },
      width: 150,
      // },
      // width: 150,
    },
    {
      field: 'statementQuantity',
      title: '结算数量',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
      slots: {
        default: ({ row }) => {
          return [<span>{row['statementQuantity']}</span>];
        },
        edit: ({ row }) => {
          return [
            <InputNumberAd
              value={row['statementQuantity']}
              max={999999999.999999}
              min={0}
              precision={4}
              onInput={(val) => ctx.updateCol(row, val, 'statementQuantity')}
            ></InputNumberAd>,
          ];
        },
      },
      width: 120,
    },
    {
      field: 'unitName',
      title: '计量单位',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
      width: 120,
    },
    {
      field: 'originalAmount',
      title: '原币结算金额（含税）',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
      slots: {
        default: ({ row }) => {
          return [<span>{row['originalAmount']}</span>];
        },
        edit: ({ row }) => {
          return [
            <InputNumberAd
              value={row['originalAmount']}
              max={999999999.999999}
              min={0}
              precision={4}
              onInput={(val) => ctx.updateCol(row, val, 'originalAmount')}
            ></InputNumberAd>,
          ];
        },
      },
      width: 150,
    },
    {
      field: 'currencyCode',
      title: '币种',
      width: 120,
    },
    {
      field: 'exchangeRate',
      title: '汇率',
      width: 120,
    },
    {
      field: 'domesticAmount',
      title: '本币结算金额（含税）',
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
      slots: {
        default: ({ row }) => {
          return [<span>{row['domesticAmount']}</span>];
        },
        edit: ({ row }) => {
          return [
            <InputNumberAd
              value={row['domesticAmount']}
              max={999999999.999999}
              min={0}
              precision={4}
              onInput={(val) => ctx.updateCol(row, val, 'domesticAmount')}
            ></InputNumberAd>,
          ];
        },
      },
      width: 150,
    },
    {
      field: 'periodDateFrom',
      title: '业务结算日期从',
      width: 240,
      editRender: {
        name: 'ElDatePicker',
        props: {
          clearable: true,
          valueFormat: 'yyyy-MM-dd',
        },
      },
    },
    {
      field: 'periodDateUntil',
      title: '业务结算日期至',
      width: 240,
      editRender: {
        name: 'ElDatePicker',
        props: {
          clearable: true,
          valueFormat: 'yyyy-MM-dd',
        },
      },
    },
    {
      field: 'businessDocCode',
      title: '业务单据编码',
      width: 150,
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
    },
    {
      field: 'productCode',
      title: '商品名称',
      width: 150,
      editRender: {
        name: 'ElSelect',
        props: {
          clearable: true,
          multiple: true,
        },
        changeMethod: 'changeMethod',
        options: ctx.goodsTypeList,
        events: { change: ctx.productCodeChange },
      },
    },
    {
      field: 'productType',
      title: '商品类型',
      width: 120,
      editRender: {
        name: 'ElSelect',
        props: {
          clearable: true,
          multiple: true,
        },
        options: ctx.goodsCategoryList,
        changeMethod: 'changeMethod',
      },
    },
    {
      field: 'productModel',
      title: '规格',
      width: 120,
      editRender: {
        name: 'ElInput',
        props: {
          clearable: true,
        },
      },
    },
  ];
};

export const tableRules = () => {
  return {
    originalPrice: [{ required: true, message: '必填项' }],
    statementQuantity: [{ required: true, message: '必填项' }],
    originalAmount: [{ required: true, message: '必填项' }],
    domesticAmount: [{ required: true, message: '必填项' }],
  };
};
